class r extends Error{constructor(t){super(`failed with error code: ${t.toString()}`),this.status=t,this.name="HttpError",void 0!==Error.captureStackTrace&&Error.captureStackTrace(this,r)}}export{r as default};
//# sourceMappingURL=HttpError.js.map
